<template>
  <div id="home">
    <div class="top">
      <img src="../assets/img/bg_img.png" />
    </div>
    <div class="con">
      <div class="inner">
        <img src="../assets/img/logo.png" />
        <PanelOne @show="showClick" />
        <PanelTwo v-if="detail" :detail="detail" />
      </div>
    </div>
    <div class="bottom" :style="{ 'position': showScroll ? 'relative' : 'absolute' }">
      <span>Copyright © 2024<a href="http://www.ncct.org.cn/" tager="_blank">广东省通讯终端产品质量监督检验中心</a>All rights reserved.</span>
      <span>技术支持:<a href="https://www.jinzhicloud.com/" tager="_blank">广东金质信息技术有限公司</a></span>
    </div>
  </div>
</template>

<script>
import PanelOne from '@/components/PanelOne.vue'
import PanelTwo from '@/components/PanelTwo.vue'
import { ref, onMounted, onUnmounted, watch } from 'vue'
export default {
  name: 'Home',
  components: {
    PanelOne,
    PanelTwo
  },
  setup() {
    let detail = ref(null);
    let showScroll = ref(false)
    let windowHeight = ref(0)
    
    let showClick = (data) => {
      detail.value = data;
      let time = setTimeout(() => {
        clearTimeout(time)
        windowHeight.value = document.getElementsByClassName('con')[0].clientHeight;
        if(windowHeight.value + 120 > document.documentElement.clientHeight) showScroll.value = true
        else showScroll.value = false
      }, 100)
    }

    const updateBodyHeight = () => {
      windowHeight.value = document.getElementsByClassName('con')[0].clientHeight;
      if(windowHeight.value + 120 > document.documentElement.clientHeight) showScroll.value = true
      else showScroll.value = false
    };

    onMounted(() => {
      window.addEventListener('resize', updateBodyHeight);
    })

    onUnmounted(() => {
      window.removeEventListener('resize', updateBodyHeight);
    })

    return {
      detail,
      showScroll,
      windowHeight,
      updateBodyHeight,
      showClick
    }
  }
}
</script>
<style lang='scss'>
  #home {
    width: 100vw;
    min-height: 100vh;
    background: #F8FBFF;
    position: relative;
    overflow-x: hidden;
    
    @media screen and (min-width:768px) {
      .con {
        width: 100vw;
        padding-bottom: 40px;
        position: relative;
        overflow-x: hidden;

        img {
          width: 770px;
          display: block;
          padding: 50px 0 40px; 
          margin: 0 auto;
          height: auto;
          // height: 60px;
        }
      }

      .panel_one,
      .panel_two  {
        width: 860px;
        padding: 40px 130px 60px;
      }

      .bottom {
        & > span {
          font-size: 14px;
        }
      }
    }
    @media screen and (max-width:767px) {
      .panel_one,
      .panel_two {
        width: 100%;
        padding: 40px;
      }

      .con {
        width: 100vw;
        padding-bottom: 40px;
        position: relative;
        overflow-x: hidden;

        img {
          width: 90%;
          display: block;
          padding: 50px 0 40px; 
          margin: 0 auto;
          height: auto;
          // height: 60px;
        }
      }
      .bottom {
        & > span {
          font-size: 10px;
        }
      }
    }

    .top {
      height: 200px;
      width: 100vw;
      position: absolute;
      top: 0;
      left: 0;
      overflow: hidden;

      img {
        width: 100vw;
      }
    }

    .bottom {
      position: relative;
      left: 0;
      bottom: 0;
      overflow-x: hidden;
      height: 80px;
      width: 100%;
      padding: 25px 0 35px;
      text-align: center;
      overflow: hidden;

      & > span {
        color: #86909c;
        line-height: 20px;
        display: inline-block;

        a {
          text-decoration: none;
          color: #4E5969;
          margin-left: 10px;
        }

        
        &:nth-child(1) {
          margin-right: 20px;

          a {
            margin: 0 10px;
          }
        } 
      }
    }
  }
  
</style>